import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  OnChanges,
  Output,
  ViewChild,
  ViewEncapsulation,
  SimpleChanges,
} from '@angular/core';
import {
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS,
  ControlValueAccessor,
  Validator,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { iif, Observable } from 'rxjs';
import { MemberModel } from '../models/member.model';
import { CriterionsService } from '../services/criterions.service';

@Component({
  selector: 'lib-members-selector',
  templateUrl: './members-selector.component.html',
  styleUrls: ['./members-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MembersSelectorComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => MembersSelectorComponent),
      multi: true,
    },
  ],
})
export class MembersSelectorComponent
  implements OnInit, OnChanges, ControlValueAccessor, Validator {
  @ViewChild(MatSelect) matSelect: MatSelect;
  @Input() mode: 'BySession' | 'ByCriterion' = 'BySession';
  @Input() bindReviewer: boolean;
  @Input() visitKey: string;
  @Input() criterionKey: string;
  @Input() sessionId: string | number;
  @Output() selectionChange: EventEmitter<MatSelectChange> =
    new EventEmitter<MatSelectChange>();
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();
  onChange: any = () => { };
  onTouch: any = () => { };
  onValidationChange: any = () => { };

  disabled = false;
  value: any = null;
  members$: Observable<MemberModel[]>;
  constructor(
    public cd: ChangeDetectorRef,
    private criterionsService: CriterionsService
  ) { }

  writeValue(value: any): void {
    this.value = value;
    this.cd.markForCheck();
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.cd.markForCheck();
  }
  validate(control: AbstractControl): ValidationErrors {
    return control.valid ? null : control.errors;
  }
  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChange = fn;
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.members$ = iif(() => this.mode == 'BySession',
      this.criterionsService.getSessionMembers(this.visitKey, this.sessionId),
      this.criterionsService.getCriterionMembers(this.visitKey, this.criterionKey));
  }

  modelChange(value) {
    this.value = value;
    this.onChange(value);
  }
  selectionChanged(event: MatSelectChange) {
    this.selectionChange.emit(new MatSelectChange(this.matSelect, event.value));
    this.valueChange.emit(event.value);
    this.onChange(event.value);
    this.onTouch();
  }
}
